export default function GentleTools() {
  return (
    <section className="w-full bg-background-50 py-12 md:py-20">
      <div className="w-full px-4 sm:px-6 lg:px-10">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row gap-10 md:gap-16 items-center">
            <div className="w-full md:w-2/5">
              <div className="relative overflow-hidden rounded-lg">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20clean%20elegant%20flat%20lay%20arrangement%20on%20a%20cream%20linen%20surface%2C%20a%20lined%20journal%20open%20to%20blank%20pages%2C%20several%20loose%20worksheet%20papers%20with%20soft%20handwritten%20notes%2C%20a%20black%20fountain%20pen%2C%20a%20ceramic%20cup%20of%20tea%2C%20a%20lit%20soy%20candle%20in%20a%20ceramic%20holder%2C%20a%20small%20potted%20succulent%20plant%2C%20soft%20natural%20daylight%20from%20above%2C%20warm%20neutral%20tones%20of%20cream%20beige%20and%20sage%2C%20calm%20organised%20aesthetic%2C%20premium%20editorial%20still%20life%20photography&width=1200&height=1200&seq=gentle-tools-2026&orientation=squarish"
                  alt="A clean flat lay arrangement with a journal, worksheet papers, fountain pen, tea, candle, and a small plant, warm neutral tones"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>

            <div className="w-full md:w-3/5">
              <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-light text-foreground-950 mb-6">
                When Everyone Else Has Gone to Bed&hellip;
              </h2>

              <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                That&rsquo;s when the battle often begins.
              </p>

              <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed mb-2">
                One drink becomes two.
              </p>
              <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed mb-2">
                Tomorrow becomes Monday.
              </p>
              <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                Monday becomes next month.
              </p>

              <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                And quietly, without anyone knowing, alcohol becomes the way you cope.
              </p>

              <div className="space-y-2 mb-4">
                <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed">
                  Not because you&rsquo;re weak.
                </p>
                <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed">
                  Not because you&rsquo;ve failed.
                </p>
              </div>

              <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                But because somewhere along the way, it became your way of managing stress, loneliness, pressure or emotional pain.
              </p>

              <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                If that&rsquo;s your story&hellip;
              </p>

              <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                You don&rsquo;t have to keep carrying it alone.
              </p>

              <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                Serena&rsquo;s Quiet Recovery Space is a private online recovery programme designed for people who want to understand why they drink, free themselves from shame and begin making meaningful changes&mdash;without anyone else needing to know.
              </p>

              <p className="font-body text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                Inside you&rsquo;ll learn how to:
              </p>

              <ul className="space-y-3 mb-6">
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-primary-500 text-sm" />
                  </div>
                  <span className="font-body text-sm text-foreground-700">Understand what&rsquo;s really driving your drinking</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-primary-500 text-sm" />
                  </div>
                  <span className="font-body text-sm text-foreground-700">Recognise your emotional triggers before they take over</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-primary-500 text-sm" />
                  </div>
                  <span className="font-body text-sm text-foreground-700">Replace automatic habits with healthier coping strategies</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-primary-500 text-sm" />
                  </div>
                  <span className="font-body text-sm text-foreground-700">Build calming evening routines that genuinely support your wellbeing</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-primary-500 text-sm" />
                  </div>
                  <span className="font-body text-sm text-foreground-700">Move forward with greater confidence, clarity and self-understanding</span>
                </li>
              </ul>

              <div className="space-y-1">
                <p className="font-body text-sm md:text-base text-foreground-600 italic">
                  🌿 Because lasting change doesn&rsquo;t begin with shame.
                </p>
                <p className="font-body text-sm md:text-base text-foreground-600 italic">
                  It begins with understanding.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}